import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import heroSms from "images/home-v2/hero-sms.svg";
import { resolveAssetUrl } from "../shared";

/**
 * Hero illustration: base SVG + animated plane, arrow-up signup badge, and SMS typing bubble.
 * Animations and overlays are hidden on mobile to reduce CPU and visual clutter.
 *
 * @returns {import("react").ReactElement}
 */
export function HeroIllustration() {
  return (
    <div className="relative mx-auto w-full max-w-[340px] md:max-w-[560px]">
      <span
        aria-hidden="true"
        className="absolute inset-[6%_8%] z-0 rounded-full bg-[radial-gradient(ellipse_at_60%_50%,rgba(3,169,244,0.18),rgba(1,118,200,0.08)_40%,transparent_70%)] blur-2xl"
      />
      <img
        src={resolveAssetUrl(heroSms)}
        alt="DojoMojo campaign dashboard preview"
        className="relative z-10 block h-auto w-full drop-shadow-[0_30px_40px_-20px_rgba(15,27,45,0.25)]"
      />

      {/* Plane — desktop only */}
      <svg
        viewBox="0 0 64 64"
        className="animate-plane-fly absolute top-[8%] -left-[6%] z-20 hidden w-14 drop-shadow-[0_8px_14px_rgba(1,118,200,0.35)] md:block"
        aria-hidden="true"
      >
        <path
          d="M2 32 L60 6 L44 58 L32 36 Z"
          fill="#fff"
          stroke="#0176c8"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path d="M32 36 L44 58 L36 44 Z" fill="#0176c8" opacity="0.25" />
      </svg>

      {/* +12,480 signups today badge */}
      <div className="animate-bob absolute bottom-[10%] -left-2 z-20 md:-left-6">
        <div className="shadow-card-hover border-line flex items-center gap-3 rounded-2xl border bg-white px-4 py-3">
          <span className="bg-teal/15 text-teal-deep inline-flex h-9 w-9 items-center justify-center rounded-xl">
            <TrendingUpIcon fontSize="small" />
          </span>
          <div>
            <div className="text-ink text-sm leading-tight font-bold">+12,480</div>
            <div className="text-muted text-[11.5px] leading-tight">signups today</div>
          </div>
        </div>
      </div>

      {/* SMS typing bubble — desktop only */}
      <div className="animate-bob-slow shadow-card border-line absolute top-[14%] -right-4 z-20 hidden items-center gap-2 rounded-2xl rounded-bl-sm border bg-white px-3.5 py-2.5 md:flex">
        <span className="bg-muted animate-typing-dot h-1.5 w-1.5 rounded-full" />
        <span
          className="bg-muted animate-typing-dot h-1.5 w-1.5 rounded-full"
          style={{ animationDelay: "0.2s" }}
        />
        <span
          className="bg-muted animate-typing-dot h-1.5 w-1.5 rounded-full"
          style={{ animationDelay: "0.4s" }}
        />
      </div>
    </div>
  );
}
